import { gql } from '@apollo/client';

export const GET_DELIVERY_TASK_PARCELS = gql`
  query GetDeliveryTaskParcels($taskId: Long!, $filter: DeliveryTaskParcelFilterInput, $page: DeliveryTaskPageRequestTypeInput) {
    getDeliveryTaskParcels(taskId: $taskId, filter: $filter, pageRequest: $page) {
      content {
        id
        trackingNo
        zipcode
        pickupStatus
        stop
        subStopNumber
        status
        deliveryAddress
        routeName
        recipientName
        recipientPhoneNumber
        recipientPhoneExtension
        deliverAt
        deliveryAttempts
        deliveredAt
        exceptionReasonCode
        markExceptionAt
        latitude
        longitude
      }
      page
      size
      totalElements
      totalPages
      hasNext
    }
  }
`;


